import { NavLink } from "react-router-dom";
import { text } from "stream/consumers";

interface Props {
    text: string;
    to: string;
    icon?: string;
}


export default function MenuItem(props: Props) {
    return (<NavLink to={props.to} >
        <p className="bg-white mx-5 px-5 py-3 rounded-lg my-2 align-middle shadow shadow-secondary-500/25"><i className={props.icon+" text-xl me-2"}></i> {props.text}</p>
    </NavLink>);
}